import axios from "axios";

const guardarProductoServicio = async (data) => {
    const token = localStorage.getItem("token");
    const config = {
        headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `${token}`,
        },
    };

    try {
        const response = await axios.post(
            `${process.env.REACT_APP_API_URL}/productos/guardar`,
            data,
            config
        );
        return [true, response.data];
    } catch (error) {
        return [false, error.status, error.response.data];
    }
}

export {
    guardarProductoServicio
}